import React from "react";

interface SummaryCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  color: "blue" | "green" | "red" | "emerald" | "purple";
}

const colorMap: Record<string, string> = {
  blue: "bg-blue-50 text-blue-600",
  green: "bg-green-50 text-green-600",
  red: "bg-red-50 text-red-600",
  emerald: "bg-emerald-50 text-emerald-600",
  purple: "bg-purple-50 text-purple-600",
};

export const SummaryCard: React.FC<SummaryCardProps> = ({ icon, label, value, color }) => {
  return (
    <div className="p-4 bg-white rounded-xl border">
      <div className="flex gap-3 items-center">
        <div className={`p-2 rounded-lg ${colorMap[color]}`}>{icon}</div>
        <div>
          <p className="text-xs text-gray-500">{label}</p>
          <p className="text-sm font-bold text-gray-800">{value}</p>
        </div>
      </div>
    </div>
  );
};
